import { render, staticRenderFns } from "./reservationModel.vue?vue&type=template&id=0b92d0ec&scoped=true&lang=pug&"
import script from "./reservationModel.vue?vue&type=script&lang=js&"
export * from "./reservationModel.vue?vue&type=script&lang=js&"
import style0 from "./reservationModel.vue?vue&type=style&index=0&id=0b92d0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b92d0ec",
  null
  
)

export default component.exports